
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class AnimatedBg extends Vue {}
